import React from 'react';
import { makeStyles } from '@material-ui/core';

import { usePanelStyles, ChannelTypeTextField } from '../ChannelPanels.model';
import { TextFormField } from 'components/designSystem/inputs/TextField';
import { LabeledSwitchField } from 'components/designSystem/LabeledSwitch';
import { DropdownFormField } from 'components/designSystem/Dropdown';
import { useTranslate } from 'ra-core';
import { DocumentFileDragDropFormField } from 'components/designSystem/DocumentFileDragDropField';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1) * -2,
  },
  wrapper: {
    display: 'flex',
    marginBottom: theme.spacing(2.5),
    marginTop: theme.spacing(1.5),
  },
  configContainer: {
    marginRight: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
  finishButtonsContainer: {
    flex: '1',
  },
  finishOptionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  textFields: {
    marginBottom: theme.spacing(1),
    marginTop: 0,
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },
  subtext: {
    fontSize: theme.spacing(1.4),
    lineHeight: theme.spacing(0.2),
    alignItems: 'center',

    marginTop: theme.spacing(1),
    color: theme.palette.text.tertiary,
  },
  setPrimaryContainer: {
    justifyContent: 'flex-end',
    position: 'relative',
    left: theme.spacing(1) * -1,
    marginBottom: theme.spacing(0.5),

    '& > div': {
      color: theme.palette.text.tertiary,
    },
  },
}));

export const PdfGeneralPanel = ({ parentChannels, readOnly }) => {
  const t = useTranslate();
  const classes = useStyles();
  const panelClasses = usePanelStyles();

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.configContainer}>
          <h2 className={panelClasses.sectionTitle}>{t('resources.channels.fields.config.about')}</h2>
          <div className={classes.finishOptionsContainer}>
            <div className={classes.optionsContainer}>
              <TextFormField
                className={classes.textFields}
                name="id"
                disabled
                size="full"
                full
                label={t('resources.channels.fields.config.channelId')}
                helperText={t('resources.channels.fields.config.helpertext')}
              />
            </div>
            <ChannelTypeTextField
              className={classes.textFields}
              name="channelType"
              disabled
              full
              size="full"
              label={t('resources.channels.fields.config.channelType')}
              helperText={t('resources.channels.fields.config.helpertext')}
            />
          </div>

          {/* nao mexer aqui pls*/}
          <div className={classes.configContainer}>
            <TextFormField
              className={classes.textFields}
              name="config.url"
              size="full"
              full
              label="URL"
              helperText={t('resources.channels.fields.config.helpertext')}
              placeholder={t('actions.insert')}
            />
            <DocumentFileDragDropFormField
              name="pdfFile"
              label={t('actions.dragOrClickPDF')}
              accept=".pdf" //colocar o formato do arquivo que dou upload
              // validate={required(t)}
            />
          </div>

          <div className={classes.configContainer}>
            <div className={classes.finishOptionsContainer}>
              <div className={classes.optionsContainer}>
                <DropdownFormField
                  name="config.parentId"
                  full
                  items={(parentChannels || []).map((c) => ({ id: c.id, name: c.name }))}
                  label={t('resources.channels.fields.config.parentId')}
                  placeholder="Selecionar"
                  helperText={t('resources.channels.fields.config.helpertext')}
                  allowEmpty
                />
              </div>
              <TextFormField
                className={classes.textFields}
                name="tag"
                size="full"
                full
                label="TAG"
                helperText={t('resources.channels.fields.config.helpertext')}
                placeholder={t('resources.channels.fields.placeholders.insertTag')}
              />
            </div>
          </div>
        </div>

        <div className={classes.configContainer}>
          <h2 className={panelClasses.sectionTitle}>{t('resources.channels.fields.config.settings')}</h2>
          <div className={classes.finishOptionsContainer}>
            <div className={classes.optionsContainer}>
              <LabeledSwitchField
                className={classes.setPrimaryContainer}
                reverse
                name="primary"
                label={t('resources.channels.fields.config.primary')}
                caption={t('resources.channels.fields.placeholders.primary')}
              />

              <LabeledSwitchField
                reverse
                className={classes.setPrimaryContainer}
                name="config.notifyOpened"
                label={t('resources.channels.fields.config.notifyOpened')}
                caption={t('resources.channels.fields.placeholders.notifyOpened')}
              />

              <LabeledSwitchField
                reverse
                className={classes.setPrimaryContainer}
                name="config.siteManagerOnly"
                label={t('resources.channels.fields.config.siteManagerOnly')}
                caption={t('resources.channels.fields.placeholders.siteManagerOnly')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
